import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReturn } from 'react-hook-form';

import { getCompanyProfile } from '../../company-profile/api';
import { CompanyProfile } from '../../company-profile/types';

import { UserProfileForm } from './use-user-profile.form';

export const useCompanyDetails = (form?: UseFormReturn<UserProfileForm>) => {
  const { refetch, isFetching: loading } = useQuery<CompanyProfile>({
    queryKey: ['companyProfile'],
    queryFn: getCompanyProfile,
    staleTime: Infinity,
    enabled: false, // Fetch only when triggered
  });

  const handleUseCompanyDetails = useCallback(async () => {
    if (!form) return; // Prevent redundant fetching

    try {
      const { data } = await refetch();
      if (!data) {
        throw new Error('No available company details');
      }

      form.reset({
        ...form.getValues(),
        address: [data.address1, data.address2].filter(Boolean).join(', '),
        suburb: data.city || '',
        state: data.state || '',
        postcode: data.post_code || '',
        phone_number: data.phone || '',
      });
    } catch {
      throw new Error('No available company details');
    }
  }, [form, refetch]);

  return { loading, handleUseCompanyDetails };
};
